<template>
  <div style="padding-top: 40px;">
    <div class="search">
      <div class="search-input">
        <input v-model="filters.q" type="search" @search="search">
      </div>
      <a href="javascript:void(0)" class="btn-filters" @click="btnFilterClickedHandler">筛选</a>
    </div>

    <p v-if="balances.length<=0 && showLoading===false" class="center" style="margin-top:12px;font-size: 14px;">暂无科目余额表</p>
    <BalanceItem
      v-for="c in balances"
      v-else
      :key="c.balanceId"
      :document-file-name="c.documentFileName"
      :company-name="c.companyName"
      :create-date="c.createDate"
      :last-update-date="c.lastUpdateDate"
      :month="c.month"
      :document-internal-name="c.documentInternalName"
    />


    <!--筛选详情-->
    <div v-if="showFilter" class="filters">
      <div class="detail">
        <p class="title">申报月份</p>
        <div class="flex mb-3">
          <input
            ref="signedDate"
            :value="filters.signedDate"
            class="input-picker"
            type="text"
            placeholder="申报月份"
            @change="filters.signedDate=refSignedDate.getDate('YYYY-MM')">
        </div>
        <!--        <p class="title">创建时间</p>-->
        <!--        <div class="flex mb-3">-->
        <!--          <input-->
        <!--            ref="signedDate"-->
        <!--            :value="filters.signedDate"-->
        <!--            class="input-picker"-->
        <!--            type="text"-->
        <!--            placeholder="起始时间"-->
        <!--            @change="filters.signedDate=refSignedDate.getDate('YYYY-MM-DD')">-->
        <!--          <span>-</span>-->
        <!--          <input-->
        <!--            ref="payDue"-->
        <!--            :value="filters.payDue"-->
        <!--            class="input-picker"-->
        <!--            type="text"-->
        <!--            placeholder="结束时间"-->
        <!--            @change="filters.payDue=refPayDue.getDate('YYYY-MM-DD')">-->
        <!--        </div>-->

        <!--        <p class="title">更新时间</p>-->
        <!--        <div class="flex mb-3">-->
        <!--          <input-->
        <!--            ref="startDate"-->
        <!--            :value="filters.startDate"-->
        <!--            class="input-picker"-->
        <!--            type="text"-->
        <!--            placeholder="起始时间"-->
        <!--            @change="filters.startDate=refStartDate.getDate('YYYY-MM-DD')">-->
        <!--          <span>-</span>-->
        <!--          <input-->
        <!--            ref="endDate"-->
        <!--            :value="filters.endDate"-->
        <!--            class="input-picker"-->
        <!--            type="text"-->
        <!--            placeholder="结束时间"-->
        <!--            @change="filters.endDate=refEndDate.getDate('YYYY-MM-DD')">-->
        <!--        </div>-->
      </div>

      <div class="btns">
        <a href="javascript:void(0)" class="btn-reset" @click="reset">重置</a>
        <a href="javascript:void(0)" class="btn-confirm" @click="confirm">确定</a>
      </div>
    </div>
    <!--筛选详情-->
  </div>
</template>

<script>
  import BalanceItem from "../../components/BalanceItem";
  import {mapGetters, mapActions} from 'vuex';
  import 'pickerjs/dist/picker.min.css'
  import Picker from 'pickerjs/dist/picker.min';

  export default {
    name: "Balances",
    components: {
      BalanceItem,
    },
    computed: {
      ...mapGetters(['balances','showLoading']),
    },
    methods: {
      ...mapActions(['getBalances']),

      btnFilterClickedHandler() {
        this.showFilter = !this.showFilter;

        if (!this.showFilter) {
          return;
        }

        setTimeout(() => {
          const config = {
            format: 'YYYY-MM',
            text: {
              title: '选择时间',
              cancel: '取消',
              confirm: '确定'
            }
          };
          this.refSignedDate = new Picker(this.$refs.signedDate, config);
          // this.refPayDue = new Picker(this.$refs.payDue, config);
          // this.refStartDate = new Picker(this.$refs.startDate, config);
          // this.refEndDate = new Picker(this.$refs.endDate, config);
        }, 100)
      },
      reset() {
        for (let key in this.filters) {
          this.filters[key] = '';
        }
      },
      confirm() {
        this.showFilter = false;
        //
        // let signMin = this.filters.signedDate ? `gte(${this.filters.signedDate})` : 'gte(1970-01-01)';
        // let signMax = this.filters.payDue ? `and(lte(${this.filters.payDue}))` : 'and(lte(2099-12-31))';
        //
        // let endMin = this.filters.startDate ? `gte(${this.filters.startDate})` : 'gte(1970-01-01)';
        // let endMax = this.filters.endDate ? `and(lte(${this.filters.endDate}))` : 'and(lte(2099-12-31))';
        // //不能用params传，因为不能有重复的signedDate
        // let ts = `?createDate=${signMin}&createDate=${signMax}`;
        // if(this.filters.startDate || this.filters.endDate){
        //   ts+=`&lastUpdateDate=${endMin}&lastUpdateDate=${endMax}`
        // }

        let params = {
          companyId: this.currentUser.companyId || null,
          month:this.filters.signedDate?this.filters.signedDate+'-01':'',
          q: this.filters.q
        };
        this.getBalances({ts: '', params: params});
      },
      search() {
        let params = {
          companyId: this.currentUser.companyId || null,
          q: this.filters.q
        };
        this.getBalances({ts: '', params: params});
      }
    },
    data() {
      return {
        showFilter: false,
        filters: {
          type: '',//合同类型
          signedDate: '',
          payDue: '',
          startDate: '',
          endDate: '',
          q: ''
        },
        refSignedDate: null,
        refPayDue: null,
        refStartDate: null,
        refEndDate: null,
      }
    },
    created() {
      
      let params = {
        companyId: this.currentUser.companyId || null
      };
      this.getBalances({ts: '', params: params});
    },
  }
</script>

<style scoped>
  .search {
    height: 40px;
    width: 100%;
    border-bottom: 1px solid #D8D8D8;
    display: flex;
    padding: 0 10px;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    z-index: 9;
    background: #fff;
    top: 0;
    left: 0;
  }

  .search .search-input {
    padding: 0 10px 0 30px;
    height: 30px;
    opacity: 1;
    border-radius: 4px;
    border: none;
    outline: none;
    flex: 1 1 auto;
    background: rgba(242, 242, 242, 1) url('../../assets/icon-search.png') 10px center no-repeat;
  }

  .search .search-input input {
    width: 100%;
    height: 30px;
    border: none;
    outline: none;
    background: transparent;
  }

  .search .btn-filters {
    text-decoration: none;
    color: #666;
    width: 50px;
    margin-left: 20px;
    position: relative;
  }

  .search .btn-filters::after {
    content: '';
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #666;
    position: absolute;
    top: 8px;
    right: 0;
  }

  .filters {
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    height: calc(100vh - 40px);
    width: 100%;
    z-index: 11;
    top: 40px;
    left: 0;
  }

  .filters .detail {
    background: #fff;
    padding: 12px;
  }

  .filters .detail .title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 16px;
  }

  .filters .detail .flex {
    display: flex;
    justify-content: space-between;
  }

  .filters .detail .btn-type {
    flex-grow: 0.2;
    height: 27px;
    border-radius: 100px;
    text-decoration: none;
    font-size: 14px;
    text-align: center;
    line-height: 27px;
    background: #F2F2F2;
    border: 1px solid #F2F2F2;
    color: #262626;
  }

  .filters .detail .btn-type.selected {
    background: rgba(249, 237, 235, 1);
    border: 1px solid rgba(222, 62, 38, 1);
    color: #DE3E26;
  }

  .filters .detail .input-picker {
    height: 27px;
    background: rgba(242, 242, 242, 1);
    border-radius: 100px;
    border: none;
    outline: none;
    color: #999;
    text-align: center;
  }

  .filters .btns {
    background: #fff;
    height: 63px;
    border-top: 1px solid rgba(216, 216, 216, 1);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .filters .btns a {
    text-decoration: none;
    margin: 0 10px;
    text-align: center;
    border-radius: 100px;
    flex-grow: 1;
    height: 35px;
    line-height: 33px;
  }

  .filters .btns a.btn-reset {
    border: 1px solid rgba(141, 141, 141, 1);
    color: #8D8D8D;
  }

  .filters .btns a.btn-confirm {
    border: 1px solid #FD493A;
    background: #FD493A;
    color: #fff;
  }
</style>